import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useQueryParams = (defaults = {}) => {
  const history = useHistory();
  const location = useLocation();

  const params = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    return Object.keys(defaults).reduce((acc, key) => {
      acc[key] = searchParams.get(key) ?? defaults[key];
      return acc;
    }, {});
  }, [defaults, location.search]);

  const setQueryParams = useCallback(
    (updates) => {
      const searchParams = new URLSearchParams(location.search);

      Object.entries(updates).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          searchParams.delete(key);
          return;
        }

        searchParams.set(key, value);
      });

      const nextSearch = searchParams.toString()
        ? `?${searchParams.toString()}`
        : '';

      if (nextSearch === location.search) return;

      history.replace({
        pathname: location.pathname,
        search: nextSearch,
      });
    },
    [history, location.pathname, location.search]
  );

  return { params, setQueryParams };
};

export default useQueryParams;
